import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { LocalStorage } from '../../../utilities/localStorage';
import { Errors } from '../../errors';
import getSession from '../../user/session/getSession';
import { getMe } from '../../user/getMe/getMe.slice';

type InitialState = {
  loading: boolean;
  data?: boolean;
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

/**
 * Oturum HttpOnly cerezde oldugu icin JS'ten gorulebilen bir oturum sinyali
 * yok. Tek yol sunucuya sormak: getMe basariliysa oturum var, 401 ise yok
 * (interceptor lokal state'i temizler).
 *
 * getMe AWAIT ediliyor: edilmezse checkToken.loading aninda false olur ve App
 * bir an login ekranini gosterir. Eskiden localStorage kontrolu senkron oldugu
 * icin bu farkedilmiyordu, artik her reload bu istege bagli.
 *
 * silent: true -> anonim yuklemede 401, POST /auth/logout ve yonlendirme
 * tetiklemesin.
 */
export const checkToken = createAsyncThunk(
  'checkToken',
  async (_, { dispatch }) => {
    const result = await dispatch(getMe({ silent: true }));

    if (!getMe.fulfilled.match(result) || !result.payload) {
      return;
    }

    // session blob'unu ~15 bilesen okuyor; cerezle gelen oturumda bu blob
    // localStorage'da olmayabilir (migration temizligi veya baska cihaz).
    if (!LocalStorage.get(LocalStorage.session)) {
      const session = await getSession();
      LocalStorage.set(LocalStorage.session, JSON.stringify(session));
    }
  }
);

const checkTokenSlice = createSlice({
  name: 'checkToken',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(checkToken.pending, (state) => {
      state.loading = true;
      state.data = false;
      state.error = undefined;
    });
    builder.addCase(checkToken.fulfilled, (state) => {
      state.loading = false;
      state.data = true;
    });
    builder.addCase(checkToken.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default checkTokenSlice.reducer;
